var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Walkthrough',{attrs:{"steps":_vm.steps,"stepCount":_vm.steps.length,"startPath":_vm.startPath,"name":_vm.name,"instructionStyle":_vm.instructionStyle,"buttonStyle":_vm.buttonStyle,"defaultPad":_vm.defaultPad}})}
var staticRenderFns = []

export { render, staticRenderFns }